import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;

      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }

      try {
        // Backend exchanges session_id → session_token cookie
        await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        await refresh();
      } catch (e) {
        // Even on error we still route to home to avoid trapping user
        console.error("Auth exchange failed", e);
      } finally {
        // Strip hash and navigate to customer area
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/kundenbereich", { replace: true });
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-[#082E19] gap-4">
      <div className="h-10 w-10 rounded-full border-2 border-[#082E19] border-t-transparent animate-spin" />
      <div className="font-mono-pp text-[11px] uppercase tracking-[0.24em] text-[#4F6858]">
        Anmeldung wird abgeschlossen…
      </div>
    </div>
  );
}
